import React, { useState } from "react";
import styled from "styled-components";
import { ICON_TYPE } from "../../../configs/constants/IconsTypes";
import { createUltimatePagination } from "react-ultimate-pagination";
import { PAGE_SIZE } from "../../../configs/constants/Pagination";

interface PaginationPropTypes {
	totalCount: number;
	pageSize?: number;
	onClickItem: (val: any) => any;
	currentPage: number;
}

interface PageWrapperPropTypes {
	isActivePage?: boolean;
}

const Pagination: React.FC<PaginationPropTypes> = ({ totalCount, onClickItem, currentPage }) => {
	const [activePage, setActivePage] = useState<number>(currentPage);

	const numberOfPages = () => {
		return Math.ceil(totalCount / PAGE_SIZE);
	};

	const WrapperComponent = ({ children }: any) => {
		return <Wrapper>{children}</Wrapper>;
	};

	const PreviousPageLink = ({ onClick }: any) => {
		return activePage !== 1 ? (
			<ArrowPrevious src={ICON_TYPE.PAGINATION_ARROW} alt="" onClick={onClick} />
		) : (
			<span />
		);
	};

	const NextPageLink = ({ onClick }: any) => {
		return activePage !== numberOfPages() ? (
			<ArrowNext src={ICON_TYPE.PAGINATION_ARROW} alt="" onClick={onClick} />
		) : (
			<span />
		);
	};

	const Page = ({ value, onClick, isActive }: any) => (
		<PageWrapper onClick={onClick} isActivePage={isActive}>
			{value}
		</PageWrapper>
	);

	const PaginatedPage = createUltimatePagination({
		itemTypeToComponent: {
			PAGE: Page,
			ELLIPSIS: () => <Page value="..." />,
			FIRST_PAGE_LINK: () => <span />,
			PREVIOUS_PAGE_LINK: PreviousPageLink,
			NEXT_PAGE_LINK: NextPageLink,
			LAST_PAGE_LINK: () => <span />,
		},
		WrapperComponent: WrapperComponent,
	});

	const onChange = (page: number) => {
		setActivePage(page);
		onClickItem(page);
	};

	return (
		<PagesWrapper>
			<PaginatedPage
				totalPages={numberOfPages()}
				currentPage={activePage}
				onChange={(page) => onChange(page)}
				hideEllipsis={numberOfPages() < 5}
			/>
		</PagesWrapper>
	);
};

export default Pagination;

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
`;
const PagesWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 3rem;
	flex-direction: column;
`;
const PageWrapper = styled.div<PageWrapperPropTypes>`
	margin-right: 2rem;
	cursor: pointer;
	font-size: ${(props) => props.theme.fontSizes.FONT_SIZE_S};
	color: ${(props) =>
		props.isActivePage ? props.theme.colors.COLOR_ACTION_BLUE : props.theme.colors.COLOR_GRAY_TEXT};
`;
const ArrowNext = styled.img`
	cursor: pointer;
`;
const ArrowPrevious = styled.img`
	cursor: pointer;
	transform: rotate(-180deg);
	margin-right: 2rem;
`;
